import { type Ref, computed } from 'vue'

import { tw } from '@backmarket/utils/string/tw'
import type { Maybe } from '@backmarket/utils/types/Maybe'
import type { IconColor } from '@ds/types/Icon'

/**
 * TODO: check with DS why fill-<color> classes are completely different with new DS
 */

const COLOR_CLASS_MAP: Record<IconColor, string> = {
  primary: tw`text-static-default-hi`,
  secondary: tw`mood-inverse text-static-default-hi`,
  success: tw`text-static-success-hi`,
  info: tw`text-static-info-hi`,
  danger: tw`text-static-danger-hi`,
  warning: tw`text-static-warning-hi`,
}

export function useColorClass(color: Ref<Maybe<IconColor>>) {
  return computed(() => {
    if (!color.value) return COLOR_CLASS_MAP.primary

    return COLOR_CLASS_MAP[color.value]
  })
}
